import { defineComponent, h, useAttrs } from 'vue'
import {
  VCardActions,
  VCardSubtitle,
  VCardText,
  VCardTitle
} from 'vuetify/components'

function createCardSectionCompat(name, Component, legacyClass) {
  Component.compatConfig = {
    ...(Component.compatConfig || {}),
    INSTANCE_ATTRS_CLASS_STYLE: false
  }

  return defineComponent({
    name,
    compatConfig: {
      RENDER_FUNCTION: false,
      COMPONENT_V_MODEL: false,
      INSTANCE_ATTRS_CLASS_STYLE: false
    },
    inheritAttrs: false,

    setup(_, { slots }) {
      const attrs = useAttrs()

      return () =>
        h(
          Component,
          {
            ...attrs,
            class: [legacyClass, attrs.class]
          },
          slots
        )
    }
  })
}

const VCardActionsCompat = createCardSectionCompat(
  'VCardActionsCompat',
  VCardActions,
  'v-card__actions'
)

const VCardSubtitleCompat = createCardSectionCompat(
  'VCardSubtitleCompat',
  VCardSubtitle,
  'v-card__subtitle'
)

const VCardTextCompat = createCardSectionCompat(
  'VCardTextCompat',
  VCardText,
  'v-card__text'
)

const VCardTitleCompat = createCardSectionCompat(
  'VCardTitleCompat',
  VCardTitle,
  'v-card__title'
)

export {
  VCardActionsCompat,
  VCardSubtitleCompat,
  VCardTextCompat,
  VCardTitleCompat
}
